import { render, staticRenderFns } from "./PartnerCompanies.vue?vue&type=template&id=279fa887&scoped=true&"
import script from "./PartnerCompanies.vue?vue&type=script&lang=js&"
export * from "./PartnerCompanies.vue?vue&type=script&lang=js&"
import style0 from "./PartnerCompanies.vue?vue&type=style&index=0&id=279fa887&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279fa887",
  null
  
)

export default component.exports